export type GameMetricsType = {
  GridSize: number;
  SubGridSize: number;
  TileSize: number;
  MaxCellsWithPoints: number;
  GameShapeCount: number;
  PointsPerGridElement: number;
  PointsPerBlock: number;
  PointsPerBlockOnWin: number;
  SpawnPoints: number;
  MaxStage: number;
};

const baseMetrics: GameMetricsType = {
  GridSize: 9,
  SubGridSize: 3,
  TileSize: 38,
  MaxCellsWithPoints: 3,
  GameShapeCount: 3,
  PointsPerGridElement: 20,
  PointsPerBlock: 1,
  PointsPerBlockOnWin: 1000,
  SpawnPoints: 50,
  MaxStage: 26,
};

const metricsOverrides: Partial<Record<number, Partial<GameMetricsType>>> = {
  2: {
    PointsPerBlockOnWin: 10,
    MaxStage: 16,
  },
};

export const getGameMetrics = (logicVersion = 1): GameMetricsType => {
  const overrides = metricsOverrides[logicVersion] ?? {};
  return { ...baseMetrics, ...overrides };
};
